import { Redirect, router } from 'expo-router';
import { ScreenContainer, YStack } from 'smoothie';

import UpgradeCheckout from '../../../billing/components/UpgradeCheckout';

// Throwaway POC screen: mirrors the Figma checkout screen's content/functionality
// (plan summary + card fields + due-today amount), not its exact visual design.
export default function UpgradeCheckoutPage() {
    if (
        process.env.EXPO_PUBLIC_FRUITFUL_ENV !== 'local' &&
        process.env.EXPO_PUBLIC_FRUITFUL_ENV !== 'sandbox' &&
        process.env.EXPO_PUBLIC_FRUITFUL_ENV !== 'staging'
    ) {
        return <Redirect href="/" />;
    }

    return (
        <ScreenContainer
            title="Premium Membership"
            hasBackButton
            onFallbackRoute="/dev/stripe/upgrade-comparison"
        >
            <YStack gap={16} padding={16} width="100%">
                <UpgradeCheckout
                    onSuccess={() => {
                        router.replace('/dev/stripe/upgrade-success');
                    }}
                />
            </YStack>
        </ScreenContainer>
    );
}
